import {getProductByID, getProductDataBySKUs} from "../api/storefront/products";
import {deleteRedirects, getRedirects} from "../api/storefront/storefront";

export async function deleteProductURLRedirects(primaryProductId, linkedSKU) {
    let fromPath; // Initialize only if the linkedSKU is provided and has a URL path
    if (linkedSKU) {
        const linkedProduct = getProductDataBySKUs(linkedSKU).find(linkedProduct => linkedProduct.sku === linkedSKU);
        fromPath = linkedProduct?.custom_url.url;
    }

    // Get primary product URL
    //TODO: Load primary product URL in UseEffect and set the value to original item for future usage
    const primaryProduct = await getProductByID(primaryProductId);
    const primaryURLPath = primaryProduct.product.custom_url.url;
    // Get redirects with matching URLs of primary product URL
    const redirects = await getRedirects(primaryURLPath.replaceAll('/', ''));
    // Make sure that the to_url is exactly the primary product URL including forward slashes
    const redirectIdList = redirects.filter(redirect => new URL('https://example.com' + redirect.to.url).pathname.replaceAll('/', '') === primaryURLPath.replaceAll('/', '') && (!fromPath || (redirect.from_path.replaceAll('/', '') === fromPath.replaceAll('/', '')))).map(redirect => redirect.id);
    await deleteRedirects(redirectIdList);
}
